import { render } from "./EndingForm.vue?vue&type=template&id=7b0af9da&scoped=true"
import script from "./EndingForm.vue?vue&type=script&lang=js"
export * from "./EndingForm.vue?vue&type=script&lang=js"

import "./EndingForm.vue?vue&type=style&index=0&id=7b0af9da&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b0af9da"]])

export default __exports__